import React from 'react';
import PropTypes from 'prop-types';

import ContentEditable from './content_editable';
import { getStandardAttributes } from '../helpers/attributes';
import sanitizeContentEditableHtml from '../helpers/sanitize_content_editable_html';

class List extends React.Component {
  static propTypes = {
    aiPromptKey: PropTypes.string,
    defaultNode: PropTypes.object.isRequired,
    highlight: PropTypes.bool,
    override: PropTypes.string,
    sanitize: PropTypes.bool,

    onAiInteraction: PropTypes.func,
    onOverrideChange: PropTypes.func.isRequired,
    onOverrideReset: PropTypes.func.isRequired
  }

  state = {
    defaultHtml: this.props.defaultNode.innerHTML.trim(),
    style: getStandardAttributes(this.props.defaultNode).style,
    tagName: this.props.defaultNode.tagName.toLowerCase()
  }

  sanitizeHtml = (html) => {
    return sanitizeContentEditableHtml(html, ['LI']);
  }

  // Prevent attempts to fully empty the list, as detected by a backspace on the last empty element.
  // Allowing it would cause any subsequently added items to be missing a class or style attribute.
  //
  // Note that selecting all in a list and backspacing the selection still leaves an empty element.
  // (Or at least it does in Chrome and Edge - Firefox behaves oddly, but is still resettable.)
  //
  // Fully removing lists from emails should be handled via a design option.
  handleKeyDown = (event) => {
    if (event.key === 'Backspace' && /^\s*<li\s*[^>]*>(<br>)?<\/li>\s*$/.test(this.props.override)) {
      event.preventDefault();
    }
  }

  render() {
    return (
      <ContentEditable
        aiPromptKey={this.props.aiPromptKey}
        className="list-component"
        contentEditableStyle={this.state.style}
        contentEditableTagName={this.state.tagName}
        defaultHtml={this.state.defaultHtml}
        highlight={this.props.highlight}
        override={this.props.override}
        sanitizer={this.props.sanitize ? this.sanitizeHtml : null}
        onAiInteraction={this.props.onAiInteraction}
        onKeyDown={this.handleKeyDown}
        onOverrideChange={this.props.onOverrideChange}
        onOverrideReset={this.props.onOverrideReset}
      />
    );
  }
}

export default List;
